import {Link} from "react-router-dom";

const Header = () => {
    return <>
        <div className='flex mt-3 shadow rounded-t-xl default-bg p-2 md:w-[95%] mx-auto'>
            <Link to={`/`} className='mx-3 text-[16px] text-orange text-bold'>فهرست مسابقات</Link>
            <Link to={`/support`} className='mx-3 text-[16px] text-orange text-bold'>ثبت نظر</Link>
        </div>
    </>
}

export default Header;